import React from "react";
import AccountView from "../views/Account/AccountView";
import { Box } from "@mui/material";
import PageTitle from "../base/PageTitle";

interface Props {}

const AccountPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="User Account" />
      <AccountView />
    </Box>
  );
};

export default AccountPage;
